module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-7.1970f89c.png";